import {
  PermissionAction,
  PermissionKey,
  type Workspace,
} from '@carboncopyco/types';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useState } from 'react';
import { usePermissionsContext } from '../../utils';
import { WorkspaceDropdown } from './WorkspaceDropdown';
import { useWorkspacesPage } from './WorkspacesPageContext';

export const WorkspacesPageTileActions = ({
  workspace,
}: {
  workspace: Workspace;
}) => {
  const flags = useFlags();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    setOpenMembersModal,
    setOpenSettingsModal,
    setOpenManageTags,
    onArchiveWorkspace,
    selectedWorkspace,
    setSelectedWorkspace,
    onLeaveWorkspace,
  } = useWorkspacesPage();
  const { getPermissions } = usePermissionsContext();
  const manageTags = getPermissions(
    PermissionKey.tag,
    PermissionAction.tagWorkspace
  );
  const archiveWorkspace = getPermissions(
    PermissionKey.workspace,
    PermissionAction.deleteWorkspaceById
  );
  const allowWorkspaceSettings = getPermissions(
    PermissionKey.workspace,
    PermissionAction.updateWorkspaceById
  );

  const isDefault = workspace.workspaceType === 'default';
  return (
    <WorkspaceDropdown
      isDefault={isDefault}
      isMenuOpen={isMenuOpen}
      setIsMenuOpen={() => {
        setSelectedWorkspace(workspace);
        setIsMenuOpen(!isMenuOpen);
      }}
      setOpenMembersModal={setOpenMembersModal}
      setOpenSettingsModal={allowWorkspaceSettings && setOpenSettingsModal}
      setOpenManageTags={flags?.partners && manageTags && setOpenManageTags}
      leaveWorkspace={
        !isDefault && selectedWorkspace?.totalMembers > 0 && onLeaveWorkspace
      }
      onArchiveWorkspace={archiveWorkspace && !isDefault && onArchiveWorkspace}
    />
  );
};
